import clsx from 'clsx'
import { type TextareaHTMLAttributes, forwardRef } from 'react'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={clsx(
        // Apple-style: white surface, hairline border, blue focus ring.
        'block w-full rounded-[var(--radius)] border bg-[var(--bg)] px-3.5 py-2.5 text-[14px] text-[var(--text)]',
        'placeholder:text-[var(--text-3)] outline-none transition-colors resize-y',
        'focus-visible:shadow-[var(--focus-ring)] focus-visible:border-[var(--accent)]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        invalid ? 'border-[var(--amber)]' : 'border-[var(--border)] hover:border-[var(--text-3)]',
        className,
      )}
      {...rest}
    />
  )
})
